// extracted by mini-css-extract-plugin
export default {"root":"not_found_root__WhJkq","contain":"not_found_contain__-0KNl"};